import { Injectable } from '@angular/core';
import { DashboardRepository } from '../../../core/data/repositories/dashboard.repositort';
import { ProjectDetails } from '../../project/model/project-details';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Injectable()
export class DashboardService {
    constructor( private dashboardDataRepository: DashboardRepository,
      private masterDataRepository :MasterDataRepository) 
    { }
    
  getAll(query){
    return this.dashboardDataRepository.getAll(query);
  }  

 update(model:ProjectDetails){
   return this.dashboardDataRepository.updateDetails(model);
 }

 getStatus(){
   return this.masterDataRepository.getPrjStatus();
 }

 getApprovalList() {
  return this.dashboardDataRepository.getApprovalList();
 }
 getAllGoalsResult(query) {
  return this.dashboardDataRepository.getAllGoalsResult(query);
 }

}